// Effect Managers
import { call, fork, take, select } from 'redux-saga/effects'

// Controller
import controller from 'fc-ctrl-soil-test-results'
import assetsCtrl from 'fc-ctrl-assets'
// Selectors
import { firstAvailableGrowerId$ } from 'fc-assets'

// Exports
export default function *start () {
  console.info('Initializing Soil Test Results 2.1.5')
  yield call(controller.start)
  yield fork(controller.watch)
  let attempts = 3
  let growerId = null

  while (attempts > 0 && !growerId) {
    attempts--
    yield take(assetsCtrl.actionTypes.receive())
    growerId = yield select(firstAvailableGrowerId$)
  }
}
